export default __webpack_public_path__ + "static/media/lk.8762f6e9.svg";